import useFeature, { useFeatureForUser } from '@/lib/features';

const useInstantPayEnabled = (): boolean => {
  const [isInstantPayEnabled] = useFeature('enterprise-ui_enableInstantPay');
  const [isInstantPayEnabledForUser] = useFeatureForUser('enterprise-ui_enableInstantPayForUsers');

  return isInstantPayEnabled && isInstantPayEnabledForUser;
};

export default useInstantPayEnabled;
